<template>
  <div>

    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Development</el-breadcrumb-item>
          <el-breadcrumb-item>Task/Component</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
        Updating Time: {{ this.updateTime }}
        </el-col> -->
    </el-row>
    <!--卡片视图区域-->

    <el-card>
      <el-form :model="formInline" class="demo-form-inline">
        <el-row>
          <el-col :span = "6">
<el-form-item label="Brand:" label-width="115px">
              <el-select v-model="formInline.brands" multiple collapse-tags
                         style="margin-left: 0px;"  filterable
                         placeholder="please choose">
                <el-option
                  v-for="item in this.brandList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span = "7">
            <el-form-item label="Sequence No:" label-width="135px">
              <el-input v-model="formInline.sequenceNo" placeholder="Sequence No" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span = "8">
            <el-form-item label="Due Date:" label-width="135px">
              <el-date-picker
                v-model="formInline.dueDate"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col  :span = "6">
            <el-form-item label="Project Name:" label-width="115px">
              <el-input v-model="formInline.projectNm" placeholder="Project Name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span = "7">
            <el-form-item label="Project Id:" label-width="135px">
              <el-input v-model="formInline.projectId" placeholder="Project Id" clearable></el-input>
            </el-form-item>

          </el-col>
          <el-col  :span = "8">
            <el-form-item label="To Do By:" v-if="this.userName.toUpperCase()==='J3P'"  label-width="135px">
              <el-select v-model="formInline.todoby"   filterable collapse-tags clearable multiple
                         style="margin-left: 0px;"
                         placeholder="please choose">
                <el-option
                  v-for="item in this.salesRepList"
                  :key="item.salesRep"
                  :label="item.salesRep"
                  :value="item.salesRep">
                  <span style="float: left">{{ item.salesRep }}</span>
                  <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="55px" v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='HBG'">
              <el-switch
                style="display: block"
                v-model="formInline.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Active"
                inactive-text="Inactive">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="this.userName.toUpperCase()==='J3P'">
          <el-col  :span = "6">
            <el-form-item label="Customer:" label-width="115px" v-if="this.userName.toUpperCase()==='J3P'">
              <el-input v-model="formInline.customer" placeholder="Customer" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span = "7">
            <el-form-item label="Contact:" label-width="135px" v-if="this.userName.toUpperCase()==='J3P'">
              <el-input v-model="formInline.contact" placeholder="Contact" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col  :span = "8">
            <el-form-item label-width="55px" v-if="this.userName.toUpperCase()==='J3P'">
              <el-switch
                style="display: block"
                v-model="formInline.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Active"
                inactive-text="Inactive">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span = "7">
            <el-form-item label="Status1:" label-width="90px">
                <el-select v-model="formInline.status" multiple collapse-tags clearable
                      style="margin-left: 0px;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusList"
                    :key="item.code"
                    :label="item.code"
                    :value="item.code">
                    <span style="float: left; width: 30px;">{{ item.code }}</span>
                    <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span= "21" style="text-align: center">
            <el-form-item >
              <el-button type="primary" @click="onSubmit" v-if="this.userName.toUpperCase()==='J3P' || this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='HBG'">Search</el-button>
              <!-- <el-button type="primary" style="margin-left: 230px;" @click="onSubmit" v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='HBG'">Search</el-button> -->
              <el-button type="primary" v-if="this.userName.toUpperCase()==='J3P'" @click="taskDialogOpen">Add</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-col :span = "8">
        <el-form-item  style="margin-left: 135px;">
          <el-button type="primary" @click="onSubmit" v-if="this.userName.toUpperCase()==='J3P'">Search</el-button>
          <el-button type="primary" style="margin-left: 230px;" @click="onSubmit" v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='HBG'">Search</el-button>
          <el-button type="primary" v-if="this.userName.toUpperCase()==='J3P'" @click="taskDialogOpen">Add</el-button>
         </el-form-item>
         </el-col>
      </el-row> -->
      </el-form>

      <el-dialog title="TASK" id="dialogTitle"
                 width="70%" :visible.sync="dialogFormVisible">
        <el-form :model="taskOpenform" width="100%" label-width="250px"  :rules="editFormRules" ref="taskOpenform" size="mini" font-size="7px">
          <div class="div-class1">
            <el-row>
              <el-col :span="9">
                <el-form-item label="Site:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.site" collapse-tags filterable
                             size="mini" style="margin-left: 0px;" v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose" @change="siteChange">
                    <el-option
                      v-for="item in this.sites"
                      :key="item.code"
                      :label="item.code"
                      :value="item.code">
                      <span style="float: left">{{ item.code }}</span>
                    </el-option>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.site" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.siteDescr"
                          disabled>
                </el-input>
              </el-col>
              <el-col :span="9">
                <el-form-item label="Sequence No:" label-width="105px" style="margin-left: 90px;">
                  <!-- <el-input v-if="this.operation==='edit' ||  @blur="getProjectList" @clear="clearCustomerEvent"this.operation==='add'" v-model="taskOpenform.crTask.sequenceNo" maxlength="20" placeholder="Sequence No" clearable></el-input> -->
                  <el-input v-model="taskOpenform.crTask.sequenceNo" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Customer:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.customer" filterable collapse-tags clearable remote reserve-keyword
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="customerChange"  :remote-method="remoteMethodCustomer" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">BP</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Company Name</span>
                      <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">Short Description</span>
                      <span style="margin-left: 70px; font-size: 10px;display:inline-block; width: 120px;">Customer Type</span>
                      <el-option
                        v-for="item in this.bpList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.name }}</span>
                        <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.shortDesc }}</span>
                        <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.type }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input  v-if="this.operation==='view'" v-model="taskOpenform.crTask.customer" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini" v-model="taskOpenform.customerCompanyNm" disabled>
                </el-input>
              </el-col>
              <el-col :span="5">
                <el-checkbox v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.hidden">Hidden</el-checkbox>
                <el-checkbox v-if="this.operation==='view'" v-model="taskOpenform.crTask.hidden" disabled>Hidden</el-checkbox>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Factory:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.contact" multiple filterable  clearable remote reserve-keyword
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"  @change="contactChange" :remote-method="remoteMethodContact" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Supplier</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Company Name</span>
                      <span style="margin-left: 130px; font-size: 10px;display:inline-block; width: 120px;">Short Description</span>
                      <el-option
                        v-for="item in this.contactCRMList"
                        :key="item.supplier"
                        :label="item.supplier"
                        :value="item.supplier">
                        <span style="float: left; width: 30px;">{{ item.supplier }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.companyName }}</span>
                        <span style="margin-left: 130px; color: #8492a6; font-size: 13px; display:inline-block; width: 60px;">{{ item.shortDescr }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.contact" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.contactName"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Project:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.projectSeqNo"  filterable collapse-tags clearable remote reserve-keyword
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="activeProjectChange" :remote-method="remoteMethodProject" :loading="loading">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 90px;">Sequence No</span>
                      <span style="margin-left: 20px; font-size: 10px;display:inline-block;width: 70px;">Brand</span>
                      <span style="margin-left: 20px; font-size: 10px;display:inline-block; width: 260px;">Project Description</span>
                      <span style="margin-left: 50px; font-size: 10px;display:inline-block; width: 120px;">Customer</span>
                      <span style="margin-left: 50px; font-size: 10px;display:inline-block; width: 120px;">Sales Rep</span>
<!--                      <el-option-->
<!--                        v-for="item in this.activeProjectList"-->
<!--                        :key="item.sequenceNo"-->
<!--                        :label="item.sequenceNo"-->
<!--                        :value="item.sequenceNo">-->
                      <el-option
                          v-for="(item, index) in activeProjectList"
                          :key="index"
                          :label="item?.sequenceNo || ''"
                          :value="item?.sequenceNo">
                        <span style="float: left; width: 90px;">{{ item.sequenceNo }}</span>
                        <span style="margin-left: 20px; color: #8492a6; font-size: 13px; display:inline-block;width: 70px;">{{ item.brand }}</span>
                        <span style="margin-left: 20px; color: #8492a6; font-size: 13px; display:inline-block; width: 260px;">{{ item.description }}</span>
                        <span style="margin-left: 50px; color: #8492a6; font-size: 13px; display:inline-block; width: 120px;">{{ item.bp }}</span>
                        <span style="margin-left: 50px; color: #8492a6; font-size: 13px; display:inline-block; width: 120px;">{{ item.salesRep }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.projectSeqNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.projectDescr"
                          :disabled="true">
                </el-input>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Priority:" label-width="150px">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.projectPriority"
                          :disabled="true">
                </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Component Type:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.category"  filterable collapse-tags clearable
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="categoryChange">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                      <el-option
                        v-for="item in this.categoryList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.category" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.categoryDescr"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Deco:" label-width="150px">
                  <el-select v-model="taskOpenform.crTask.deco"  multiple filterable  collapse-tags clearable
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="decoChange">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                      <el-option
                        v-for="item in this.decoList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.deco" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.decoDescr"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="Material:" label-width="150px" prop="crTask.material">
                  <el-select v-model="taskOpenform.crTask.material"  filterable collapse-tags clearable
                             style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                             placeholder="please choose"   @change="materialChange">
                    <el-option-group>
                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                      <el-option
                        v-for="item in this.materialList"
                        :key="item.code"
                        :label="item.code"
                        :value="item.code">
                        <span style="float: left; width: 30px;">{{ item.code }}</span>
                        <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.material" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-input style="margin-left: 10px;" size="mini"
                          v-model="taskOpenform.materialDescr"
                          disabled>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8.6">
                <el-form-item label="Item Number:" label-width="150px">
                  <!-- <el-select v-model="taskOpenform.crTask.product"  filterable collapse-tags clearable remote reserve-keyword
                        style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose"   @change="productChange" :remote-method="remoteMethodProduct" :loading="loading">
                        <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 120px;">Product</span>
                              <span style="margin-left: 20px; font-size: 10px;display:inline-block;width: 150px;">Description1</span>
                              <span style="margin-left: 75px; font-size: 10px;display:inline-block; width: 150px;">Description2</span>
                              <span style="margin-left: 50px; font-size: 10px;display:inline-block; width: 90px;">Brand</span>
                              <span style="margin-left: 50px; font-size: 10px;display:inline-block; width: 120px;">Project</span>
                      <el-option
                      v-for="item in this.productList"
                      :key="item.product"
                      :label="item.product"
                      :value="item.product">
                      <span style="float: left; width: 120px;">{{ item.product }}</span>
                      <span style="margin-left: 20px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description1 }}</span>
                      <span style="margin-left: 75px; color: #8492a6; font-size: 13px; display:inline-block; width: 150px;">{{ item.description2 }}</span>
                      <span style="margin-left: 50px; color: #8492a6; font-size: 13px; display:inline-block; width: 90px;">{{ item.project }}</span>
                      <span style="margin-left: 50px; color: #8492a6; font-size: 13px; display:inline-block; width: 120px;">{{ item.category }}</span>
                    </el-option>
                    </el-option-group>
                  </el-select> -->
                  <el-input style="margin-left: 15px;" size="mini" v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.product"></el-input>
                  <el-input style="width: 232px;" v-if="this.operation==='view'" v-model="taskOpenform.crTask.product" disabled></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="5">
              <el-input style="margin-left: 10px;" size="mini"
                v-model="taskOpenform.productDescr"
                :disabled="true">
              </el-input>
              </el-col> -->
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="Completed:" label-width="150px">
                  <el-checkbox  v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.completed" placeholder="Completed" @change="completeChanged" clearable></el-checkbox>
                  <el-checkbox  v-if="this.operation==='view'" v-model="taskOpenform.crTask.completed" disabled></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="div-class2" line-height="50%">
            <template>
              <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="Records" name="task">
                  <div class="div-title-class">Report</div>
                  <div class="div-class">
                    <el-form-item label-width="0px" class="textarea-class">
                      <el-input v-if="this.operation==='edit' || this.operation==='add'" type="textarea" autosize v-model="taskOpenform.crTask.report"></el-input>
                      <el-input v-if="this.operation==='view'" type="textarea" autosize v-model="taskOpenform.crTask.report" disabled></el-input>
                    </el-form-item>
                  </div>

                  <div class="div-titlefin-class">Capacity</div>
                  <div class="div-project-class">
                    <el-row>
                      <el-col :span="7">
                        <el-form-item label="Capacity/Day:" prop="capacityDay" label-width="150px">
                          <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.days" placeholder="Capacity/Day" clearable></el-input>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.days" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="Number of Cavities:" prop="moldNbr" label-width="150px">
                          <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.moldNbr" placeholder="Number of Cavities" clearable></el-input>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.moldNbr" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col :span="7">
                        <el-form-item label="Lead Time:" prop="leadTime" label-width="150px">
                          <el-select v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.leadTime" placeholder="Please choose">
                            <el-option
                              v-for="item in this.leadTimeValues"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.leadTime" disabled></el-input>
                        </el-form-item>
                      </el-col> -->
                      <!-- <el-form-item label="Lead Time:" prop="leadTime" label-width="150px">
                        <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.leadTime" placeholder="Lead Time" clearable></el-input>
                        <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.leadTime" disabled></el-input>
                        </el-form-item> -->
                      <!-- </el-col> -->
                    </el-row>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Next Step" name="second">
                  <div class="div-nextstep-class1">
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="Status:" label-width="150px" prop="crTask.status">
                          <el-select v-model="taskOpenform.crTask.status"  filterable collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="statusChange">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                                v-for="item in this.statusList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                            </el-option-group>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.status" disabled></el-input>
                          <!-- <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.status" disabled></el-input> -->
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="taskOpenform.statusDescr"
                                  disabled>
                        </el-input>
                      </el-col>
                      <!-- <el-col :span="6">
                        <el-form-item label="Component Type:" label-width="150px">
                          <el-select v-model="taskOpenform.crTask.category"  filterable collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="categoryChange">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                                v-for="item in this.categoryList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                            </el-option-group>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.category" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="taskOpenform.categoryDescr"
                                  disabled>
                        </el-input>
                      </el-col> -->
                      <el-col :span="7">
                        <el-form-item label="To Do By:" label-width="180px"  prop="crTask.taskTobe">
                          <el-select v-model="taskOpenform.crTask.taskTobe" filterable collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="salesRepChange">
                            <el-option
                              v-for="item in this.salesRepList"
                              :key="item.salesRep"
                              :label="item.salesRep"
                              :value="item.salesRep">
                              <span style="float: left">{{ item.salesRep }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.taskTobe" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col :span="5">
                        <el-form-item label="Lead Time:" prop="leadTime" label-width="90px">
                          <el-select v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.leadTime" placeholder="Please choose">
                            <el-option
                              v-for="item in this.leadTimeValues"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.leadTime" disabled></el-input>
                        </el-form-item>
                      </el-col> -->
                    </el-row>
                    <el-row></el-row>

                    <!-- <el-row>
                      <el-col :span="6">
                        <el-form-item label="Deco:" label-width="150px">
                          <el-select v-model="taskOpenform.crTask.deco"   multiple filterable  collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="decoChange">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                                v-for="item in this.decoList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                            </el-option-group>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.deco" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="taskOpenform.decoDescr"
                                  disabled>
                        </el-input>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="Material:" label-width="180px" prop="crTask.material">
                          <el-select v-model="taskOpenform.crTask.material"  filterable collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="materialChange">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                                v-for="item in this.materialList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                            </el-option-group>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.material" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="taskOpenform.materialDescr"
                                  disabled>
                        </el-input>
                      </el-col>
                    </el-row> -->

                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="Lead Time:" prop="leadTime" label-width="150px">
                          <el-select v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.leadTime" placeholder="Please choose">
                            <el-option
                              v-for="item in this.leadTimeValues"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.leadTime" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">&nbsp;
                        </el-col>
                      <!-- <el-col :span="6">
                        <el-form-item label="Status:" label-width="150px" prop="crTask.status">
                          <el-select v-model="taskOpenform.crTask.status"  filterable collapse-tags clearable
                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose"   @change="statusChange">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                                v-for="item in this.statusList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                            </el-option-group>
                          </el-select>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.status" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-input style="margin-left: 10px;" size="mini"
                                  v-model="taskOpenform.statusDescr"
                                  disabled>
                        </el-input>
                      </el-col> -->
                      <el-col :span="7">
                        <el-form-item label="Due date:" label-width="180px"  prop="crTask.dueDate">
                          <el-date-picker v-if="this.operation==='edit' || this.operation==='add'"
                                          v-model="taskOpenform.crTask.dueDate"
                                          type="date"   value-format="yyyy-MM-dd"
                                          placeholder="choose date">
                          </el-date-picker>
                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.dueDate" disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div class="div-title-class">Description</div>
                  <div class="div-project-class">
                    <el-form-item label-width="0px" class="textarea-class">
                      <el-input v-if="this.operation==='edit' || this.operation==='add'" type="textarea" autosize v-model="taskOpenform.crTask.description"></el-input>
                      <el-input v-if="this.operation==='view'" type="textarea" autosize v-model="taskOpenform.crTask.description" disabled></el-input>
                    </el-form-item>
                  </div>
                  <div class="div-titlefin-class">Source</div>
                  <div class="div-project-class">
                    <el-row>
                      <el-col :span="8">
                        <el-form-item label="Project Leader:" label-width="150px" prop="crProject.projectLeader">
                          <el-select v-model="taskOpenform.crTask.projectLeader" collapse-tags filterable clearable disabled
                                     size="mini" style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-model="taskOpenform.crTask.projectLeader" v-if="this.operation==='view'" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="created by:" label-width="180px" prop="crTask.createBy">
                          <el-select v-model="taskOpenform.crTask.createBy"  filterable collapse-tags  clearable
                                     style="margin-left: 0px;"    v-if="this.operation==='add'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view' || this.operation==='edit'" v-model="taskOpenform.crTask.createBy" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8" v-if="this.operation==='edit' || (this.operation==='view' && (taskOpenform.crTask.updateBy !== null || taskOpenform.crTask.updateBy !== ''))">
                        <el-form-item label="updated by:" label-width="180px" prop="crTask.updateBy">
                          <el-select v-model="taskOpenform.crTask.updateBy" filterable collapse-tags   clearable
                                     style="margin-left: 0px;"    v-if="this.operation==='edit'"
                                     placeholder="please choose">
                            <el-option
                              v-for="item in this.createdList"
                              :key="item.userId"
                              :label="item.userName"
                              :value="item.userId">
                              <span style="float: left">{{ item.userId }}</span>
                              <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.userName }}</span>
                            </el-option>
                          </el-select>
                          <el-input v-if="this.operation==='view' && (taskOpenform.crTask.updateBy !== null || taskOpenform.crTask.updateBy !== '')" v-model="taskOpenform.crTask.updateBy" disabled></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Reference" name="reference">
                  <div class="div-title-class">Picture</div>
                  <div class="div-class">
                    <el-upload
                      class="upload-demo"
                      v-model="taskOpenform.picReference"
                      action="https://www.myirequest.com:8081/customer/taskFileUpload"
                      multiple
                      show-file-list
                      :before-upload="beforeUpload"
                      :on-preview="handlePreview"
                      :on-success="handleSuccessPic"
                      :file-list="picList"
                      :on-remove="handleRemovePic"
                      list-type="picture">
                      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
                      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">png/gif/jpg/jpeg files with a size less than 10mb</div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                  </div>
                  <div class="div-titlefin-class">Document</div>
                  <div class="div-class">
                    <el-upload
                      class="upload-demo"
                      v-model="taskOpenform.docReference"
                      action="https://www.myirequest.com:8081/customer/taskFileUpload"
                      multiple
                      show-file-list
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .csv"
                      :on-preview="handlePreviewDoc"
                      :on-success="handleSuccessDoc"
                      :on-remove="handleRemoveDoc"
                      :file-list="docList"
                      list-type="text">
                      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
                      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">docx/xlsx/xls/ppt/pptx/csv/pdf files with a size less than 500kb</div>
                    </el-upload>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="PDR" name="pdr">
                  <div class="div-title-class">PDR</div>
                  <div class="div-nextstep-class1">
                    <el-row>
<!--                      <el-col :span="6">-->
<!--                        <el-form-item label="Component:" label-width="150px">-->
<!--                          <el-select v-model="taskOpenform.crTask.component"  filterable collapse-tags clearable-->
<!--                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"-->
<!--                                     placeholder="please choose"   @change="categoryChange">-->
<!--                            <el-option-group>-->
<!--                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>-->
<!--                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>-->
<!--                              <el-option-->
<!--                                v-for="item in this.categoryList"-->
<!--                                :key="item.code"-->
<!--                                :label="item.code"-->
<!--                                :value="item.code">-->
<!--                                <span style="float: left; width: 30px;">{{ item.code }}</span>-->
<!--                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>-->
<!--                              </el-option>-->
<!--                            </el-option-group>-->
<!--                          </el-select>-->
<!--                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.component" disabled></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="6">-->
<!--                        <el-input style="margin-left: 10px;" size="mini"-->
<!--                                  v-model="taskOpenform.categoryDescr"-->
<!--                                  disabled>-->
<!--                        </el-input>-->
<!--                      </el-col>-->
<!--                      <el-col :span="9">-->
<!--                        <el-form-item label="Sub Component:" label-width="180px">-->
<!--                          <el-select v-model="taskOpenform.crTask.subComponent" filterable collapse-tags clearable-->
<!--                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"-->
<!--                                     placeholder="please choose">-->
<!--                            <el-option-->
<!--                              v-for="item in this.subComponentList"-->
<!--                              :key="item"-->
<!--                              :label="item"-->
<!--                              :value="item">-->
<!--                            </el-option>-->
<!--                          </el-select>-->
<!--                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.subComponent" disabled></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
                    </el-row>
                    <el-row>
                      <el-col :span="6">
<!--                        <el-form-item label="Material:" label-width="150px">-->
<!--                          <el-select v-model="taskOpenform.crTask.material2"  filterable collapse-tags clearable-->
<!--                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"-->
<!--                                     placeholder="please choose"   @change="materialChange">-->
<!--                            <el-option-group>-->
<!--                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>-->
<!--                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>-->
<!--                              <el-option-->
<!--                                v-for="item in this.materialList"-->
<!--                                :key="item.code"-->
<!--                                :label="item.code"-->
<!--                                :value="item.code">-->
<!--                                <span style="float: left; width: 30px;">{{ item.code }}</span>-->
<!--                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>-->
<!--                              </el-option>-->
<!--                            </el-option-group>-->
<!--                          </el-select>-->
<!--                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.material2" disabled></el-input>-->
<!--                        </el-form-item>-->
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="Size:" label-width="120px">
                        <el-input style="margin-left: 0px;" size="mini" oninput="value=value.replace(/[^\d]/g,'')"  v-if="this.operation==='edit' || this.operation==='add'"
                                  v-model="taskOpenform.crTask.size">
                        </el-input>
                        <el-input style="margin-left: 0px;" size="mini"   v-if="this.operation==='view'"  disabled
                                  v-model="taskOpenform.crTask.size">
                        </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="Weight:" label-width="180px" prop="crTask.weight">
                        <el-input v-model="taskOpenform.crTask.weight" oninput="value=value.replace(/[^\d]/g,'')" style="width: 200px;" v-if="this.operation==='edit' || this.operation==='add'">
                            <el-select v-model="taskOpenform.crTask.weightUnit" slot="append" placeholder="g" style="width:70px">
                              <el-option label="g" value="g"></el-option>
                              <el-option label="gsm" value="gsm"></el-option>
                            </el-select>
                          </el-input>
                          <el-input v-model="taskOpenform.crTask.weight" style="width: 200px;" v-if="this.operation==='view'" disabled>
                              <el-select v-model="taskOpenform.crTask.weightUnit" slot="append" placeholder="g" style="width:70px">
                                <el-option label="g" value="g"></el-option>
                                <el-option label="gsm" value="gsm"></el-option>
                              </el-select>
                            </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
<!--                        <el-form-item label="Decoration:" label-width="150px">-->
<!--                          <el-select v-model="taskOpenform.crTask.decoration"      clearable-->
<!--                                     style="margin-left: 0px;"  v-if="this.operation==='edit' || this.operation==='add'"-->
<!--                                     placeholder="please choose">-->
<!--                            <el-option-group>-->
<!--                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>-->
<!--                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>-->
<!--                              <el-option-->
<!--                                v-for="item in this.decoList"-->
<!--                                :key="item.code"-->
<!--                                :label="item.code"-->
<!--                                :value="item.code">-->
<!--                                <span style="float: left; width: 30px;">{{ item.code }}</span>-->
<!--                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>-->
<!--                              </el-option>-->
<!--                            </el-option-group>-->
<!--                          </el-select>-->
<!--                          <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.decoration" disabled></el-input>-->
<!--                        </el-form-item>-->
                      </el-col>
                      <el-col :span="6">
                          <el-form-item label="Printing:" label-width="120px">
                            <el-select v-model="taskOpenform.crTask.printing" clearable
                                       style="margin-left: 0px;"     v-if="this.operation==='edit' || this.operation==='add'"
                                       placeholder="please choose">
                              <el-option
                                v-for="item in this.printingList"
                                :key="item"
                                :label="item"
                                :value="item">
                              </el-option>
                            </el-select>
                            <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.printing" disabled></el-input>
                          </el-form-item>
                          </el-col>
                          <el-col :span="9">
                         <el-form-item label="Finish:" label-width="180px">
                           <el-select v-model="taskOpenform.crTask.finish"  style="margin-left: 0px;" clearable
                                         v-if="this.operation==='edit' || this.operation==='add'"
                                      placeholder="please choose">
                             <el-option
                               v-for="item in ['Matte','Glossy','Satin']"
                               :key="item"
                               :label="item"
                               :value="item">
                             </el-option>
                           </el-select>
                           <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.finish" disabled></el-input>
                         </el-form-item>
                      </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6">
                          <el-form-item label="MOQ:" label-width="150px">
                            <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.moq"></el-input>
                            <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.moq" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="Drawing Number:" label-width="150px">
                            <el-input v-if="this.operation==='edit' || this.operation==='add'" v-model="taskOpenform.crTask.drawingNbr"></el-input>
                            <el-input v-if="this.operation==='view'" v-model="taskOpenform.crTask.drawingNbr" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                        <el-upload
                          class="avatar-uploader"
                          ref="upload"
                          :limit="1"
                          :action="uploadImgUrl"
                          :before-upload="beforeAvatarUpload"
                          :on-success="handleAvatarSuccess"
                          :show-file-list ="false"
                          :multiple="false"
                          accept=".jpg, .png"
                        >
                          <img v-if="taskOpenform.drawingFile" :src="taskOpenform.drawingFile" class="avatar">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          <div class="el-upload__tip" slot="tip">Must be JPG/PNG and less than 2MB</div>
                        </el-upload>
                          <!-- <el-upload
                            class="upload-demo"
                            v-model="taskOpenform.drawingFile"
                            action="http://localhost:8081/customer/drawingFileUpload"
                            :data="{taskId: taskOpenform.crTask.sequenceNo}"
                            multiple disabled
                            show-file-list
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .csv"
                            :on-preview="handlePreviewDoc"
                            :on-success="handleSuccessDoc"
                            :on-remove="handleRemoveDoc"
                            :file-list="docList"
                            list-type="text">
                            <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
                          </el-upload> -->
                        <!-- </div> -->
                        </el-col>
                        </el-row>
                        </div>
                </el-tab-pane>
              </el-tabs>
            </template>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="this.operation==='edit' || this.operation === 'add'" @click="dialogFormVisible = false">Cancel</el-button>
          <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="taskDialogSave('taskOpenform')">Save</el-button>
        </div>
     </el-dialog>
      <el-dialog  :title="`PDR`+`_`+pdrOpenform.pdr.projectId+`_`+pdrOpenform.pdr.projectDescr+`_`+pdrOpenform.pdr.createTime" style="text-align: center;"
    width="82%" :visible.sync="pdrDialogFormVisible">
    <el-form :label-position="labelPosition" :model="pdrOpenform" width="100%" label-width="250px">
      <div class="div-table">
      <table class="table-body" cellspacing=0 cellpadding=0>
          <tbody>
              <tr>
                  <td width="100%" colspan="8" class="section-header">Specification & Quotation</td>
              </tr>
              <tr>
                <td width="15%" class="header" colspan="1">Project Id:</td>
                <td width="10%" colspan="2">
                  <div style="text-align: left;">{{pdrOpenform.pdr.projectId}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectId}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectId" type="text"
                    class="item-input1" readonly="readonly"/>-->
                </td>
                <td colspan="2" width="20%" class="header">Project Descr:</td>
                <td colspan="3" width="30%"><div style="text-align: left;">{{pdrOpenform.pdr.projectDescr}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectDescr" type="text"
                     class="item-input1" readonly="readonly"/>-->
                </td>
                </tr>
                <template v-if="userName.toUpperCase()==='J3P'">
                <tr>
                  <td width="15%" class="header" colspan="1">Customer Name:</td>
                              <td colspan="2"><div style="text-align: left;">{{pdrOpenform.pdr.customerId}}</div>
                              <!--<el-select v-model="pdrOpenform.pdr.customerName" collapse-tags
                        size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>-->
                  </td><td colspan="2" width="20%" class="header">Task Id:</td>
                <td colspan="3" width="30%"><div style="text-align: left;">{{pdrOpenform.pdr.taskId}}</div>
                  <!--<div style="text-align: left;" v-if="this.operation==='view'">{{pdrOpenform.pdr.projectDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.projectDescr" type="text"
                     class="item-input1" readonly="readonly"/>-->
                </td>
                </tr></template>
                <template v-else>
                <tr>
                  <td width="15%" class="header" colspan="1">Customer Name:</td>
                              <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.customerId}}</div>
                              <!--<el-select v-model="pdrOpenform.pdr.customerName" collapse-tags
                        size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>-->
                  </td>
                </tr>
                </template>
                <tr>
                  <td width="15%" class="header">Brand:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.brand}}</div>
                    <!--<input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.brand" type="text"
                      class="item-input1" readonly="readonly"/>-->
                  </td>
                </tr>
                <tr>
                    <td width="15%" class="header">Vendor:</td>
                    <td colspan="7">
                      <div style="text-align: left;">{{pdrOpenform.pdr.drawingNbr}}</div>
                      <!--<input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.drawingNbr" type="text"
                        class="item-input1"/>--></td>
                      <!-- <input type="text" v-model="pdrOpenform.pdr.drawing_nbr" width="100%" class="item-input"/></td> -->
                </tr>
                <tr>
                <td width="15%" class="header" colspan="1">Item:</td>
                            <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.item}}</div>
                            <!--<el-select v-model="pdrOpenform.pdr.item"  filterable collapse-tags clearable
                                  style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                  placeholder="please choose"  size="mini">
                                  <el-option-group>
                                        <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                                        <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                                <el-option
                                v-for="item in this.categoryList"
                                :key="item.code"
                                :label="item.code"
                                :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                              </el-option>
                              </el-option-group>
                            </el-select>-->
                            <!-- <input v-if="this.operation==='edit' || this.operation==='add'" v-model="pdrOpenform.pdr.item" type="text"
                               width="100%"  class="item-input" /> --></td>
                               </tr>
              <tr>
                  <td width="15%" class="header">Component Description:</td>
                  <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.componentDescr}}</div>
                  </td>
                    <!-- <input type="text" v-model="pdrOpenform.pdr.componentDescr" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
              <td width="15%" class="header" colspan="1">Material:</td>
                          <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.material}}</div>
                          <!--<el-select v-model="pdrOpenform.pdr.material"  filterable collapse-tags clearable
                                style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                placeholder="please choose"  size="mini">
                              <el-option
                              v-for="item in this.material"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select>-->
                          </td>
                             </tr>
              <tr>
              <td width="15%" class="header" colspan="1">Capacity:</td>
                          <td colspan="7"><div style="text-align: left;">{{pdrOpenform.pdr.capacity}}</div>
                          <!--<el-select v-model="pdrOpenform.pdr.capacity"  filterable collapse-tags clearable
                                style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                placeholder="please choose"  size="mini">
                            <el-option-group>
                              <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                              <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                            <el-option
                              v-for="item in this.capacityL"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                                <span style="float: left; width: 30px;">{{ item.code }}</span>
                                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                            </el-option>
                             </el-option-group>
                          </el-select>--></td>
                             </tr>
              <tr>
                  <td width="15%" class="header">Weight:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.weight}}</div>
                    </td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Cavitation:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.cavitation}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.cavitation" type="number"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Color:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.color}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.color" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Size:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.size}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.size" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">Details:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.revision}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.revision" type="text"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header">MOQ:</td>
                  <td colspan="7">
                    <div style="text-align: left;">{{pdrOpenform.pdr.moq}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.moq" type="number" step="1"
                      class="item-input1"/></td>
                    <!--  <input type="number" v-model="pdrOpenform.pdr.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Bottle Unit Price w/o Option (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.bottleSuppPrice}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.bottleSuppPrice" type="number"
                                       class="item-input"  /></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.bottleSpcPrice}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.bottleSpcPrice" type="number"
                                       class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.bottleSalePrice}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.bottleSalePrice" type="number"
                                      step="0.01" class="item-input"/></td>
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Total Tooling Price (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalToolingSupp}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalToolingSupp" type="number"
                                      disabled class="item-input"/></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalToolingSpc}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalToolingSpc" type="number"
                                      disabled  class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalToolingSale}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalToolingSale" type="number"
                                      step="0.01" class="item-input"/></td>
              </tr>
              <tr>
                  <td width="15%" class="header" colspan="1">Total Unit Price (USD):</td>
                  <td width="10%" colspan="1">Supplier Price (RMB)</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalUnitSupp}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalUnitSupp" type="number"
                                      disabled step="0.01" class="item-input"/></td>
                  <td width="10%" colspan="1">SPC Price (USD):</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalUnitSpc}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalUnitSpc" type="number"
                                      disabled step="0.01" class="item-input"/></td>
                  <td width="20%" colspan="2">Sale To Customer</td>
                  <td width="10%" colspan="1"><div style="text-align: left;">{{pdrOpenform.pdr.totalUnitSale}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdr.totalUnitSale" type="number"
                                       step="0.01" class="item-input"/></td>
              </tr>
              <tr></tr>
              <template v-if = "componentType==='BS'">
              <tr>
                  <td width="100%" class="section-header" colspan="8" rowspan="1">Bottle Options</td>
              </tr>
              <tr>
                <td width="15%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1">Tooling Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.toolingPriceR}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.toolingPriceR" type="number"
                                      @blur="checkToolingPriceR" class="item-input"/>--></td>
                <td width="10%" class="header1">Tooling Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.toolingPriceSpc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.toolingPriceSpc" type="number"
                                    @blur="checkToolingPriceSpc"  class="item-input"/>--></td>
              </tr>
              <tr>
                <td width="15%" class="header">Fire Polish</td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.firePolish}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.firePolish" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in firePolishList"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1"></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPricePolishR}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPricePolishR" type="number"
                                      @blur="checkUnitPriceR" class="item-input"/>--></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPricePolishSpc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPricePolishSpc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/>--></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 1</td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process1}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process1" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in this.process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.color1}}</div>
                                    <input placeholder="color" v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.color1" type="text"
                                      class="item-input"/></td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process1Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process1Back" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header">
                  <div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice1R}}</div>
                                      <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice1R" type="number"
                                      @blur="checkUnitPriceR"  class="item-input"/>--></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice1Spc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice1Spc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/>--></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 2</td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process2}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process2" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1">
                  <div style="text-align: left;">{{pdrOpenform.pdrBottle.color2}}</div>
                                      <input placeholder="color" v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.color2" type="text"
                                        class="item-input"/></td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process2Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process2Back" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>
                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice2R}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice2R" type="number"
                                    @blur="checkUnitPriceR"  class="item-input"/>--></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice2Spc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice2Spc" type="number"
                                    @blur="checkUnitPriceSpc"  class="item-input"/>--></td>
              </tr>
              <tr>
                <td width="15%" class="header">Process 3</td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process3}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process3" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in process"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
                </td>
                <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrBottle.color3}}</div>
                                    <input placeholder="color" v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.color3" type="text"
                                      class="item-input"/></td>
                <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrBottle.process3Back}}</div>
                            <el-select v-model="pdrOpenform.pdrBottle.process3Back" collapse-tags
                      size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                      placeholder="please choose">
                    <el-option
                    v-for="item in finish"
                    :key="item"
                    :label="item"
                    :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select></td>

                <td width="10%" class="header1">Unit Price (RMB)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice3R}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice3R" type="number"
                                     @blur="checkUnitPriceR" class="item-input"/>--></td>
                <td width="10%" class="header1">Unit Price (USD)</td>
                <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrBottle.unitPrice3Spc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrBottle.unitPrice3Spc" type="number"
                                     @blur="checkUnitPriceSpc" class="item-input"/>--></td>
              </tr>
              </template>
              <template v-if="componentType!=='FC' && componentType !== 'BS'">
              <tr>
                  <td width="100%" class="section-header" colspan="8" rowspan="1">Component Options</td>
              </tr>
              <tr>
                <td width="15%" class="header">Sub-Component 1 Description</td>
                <td width="10%" class="header1">top</td>
                <td width="10%" class="header1">Material</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Material}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Material" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in this.material"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select></td>
                                    <td width="10%" class="header1">Tooling Price (RMB)</td>
                                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1ToolingPriceR}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1ToolingPriceR" type="number"
                                      @blur="checkToolingPriceR" class="item-input"/>--></td>
                                    <td width="10%" class="header1">Tooling Price (USD)</td>
                                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1ToolingPriceSpc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1ToolingPriceSpc" type="number"
                                    @blur="checkToolingPriceSpc"  class="item-input"/>--></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 1</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Process1}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process1" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%" class="header1">details 1</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Detail1}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail1" type="text"
                                      class="item-input"/></td>
                                    <td width="10%" class="header1">Unit Price (RMB)</td>
                                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1UnitPriceR}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1UnitPriceR" type="number"
                                      @blur="checkUnitPriceR"    class="item-input"/>--></td>
                                    <td width="10%" class="header1">Unit Price (USD)</td>
                                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1UnitPriceSpc}}</div>
                                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1UnitPriceSpc" type="number"
                                      @blur="checkUnitPriceSpc" class="item-input"/>--></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 2</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Process2}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process2" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%" style="text-align: center;">Details 2</td>
                                    <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Detail2}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail2" type="text"
                                      class="item-input"/></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Process 3</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Process3}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Process3" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in process"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%" style="text-align: center;">Details 3</td>
                                    <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Detail3}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Detail3" type="text"
                                      class="item-input"/></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                    <td width="15%" class="header">Finish</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Finish}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Finish" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in finish"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select>
                                    </td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                </tr>
                                <tr>
                                    <td width="15%" class="header">Cavitation</td>
                                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Cavitation}}</div>
                                                <el-select v-model="pdrOpenform.pdrFactice.comp1Cavitation" collapse-tags
                                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                          placeholder="please choose">
                                        <el-option
                                        v-for="item in [1,2,4,6,8]"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                        <span style="float: left">{{ item }}</span>
                                      </el-option>
                                    </el-select></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                    <td width="10%"></td>
                                  </tr>
                                  <tr>
                                      <td width="15%" class="header">Color</td>
                                      <td width="10%">
                                    <div style="text-align: left;">{{pdrOpenform.pdrFactice.comp1Color}}</div>
                                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp1Color" type="text"
                                      class="item-input"/>
                                      </td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                  </tr>
              <tr>
                  <td width="15%" class="header">Sub-Component 2 Description</td>
                  <td width="10%" class="header1">base</td>
                  <td width="10%" class="header1">Material</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Material}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Material" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in this.material"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select></td>
                                      <td width="10%" class="header1">Tooling Price (RMB)</td>
                                      <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2ToolingPriceR}}</div>
                                      <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2ToolingPriceR" type="number"
                                        @blur="checkToolingPriceR" class="item-input"/>--></td>
                                      <td width="10%" class="header1">Tooling Price (USD)</td>
                                      <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2ToolingPriceSpc}}</div>
                                      <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2ToolingPriceSpc" type="number"
                                      @blur="checkToolingPriceSpc"  class="item-input"/>--></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 1</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Process1}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process1" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%" class="header1">details 1</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Detail1}}</div>
                                      <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail1" type="text"
                                        class="item-input"/></td>
                                      <td width="10%" class="header1">Unit Price (RMB)</td>
                                      <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2UnitPriceR}}</div>
                                      </td>
                                      <td width="10%" class="header1">Unit Price (USD)</td>
                                      <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2UnitPriceSpc}}</div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 2</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Process2}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process2" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%" style="text-align: center;">Details 2</td>
                                      <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Detail2}}</div>
                                      <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail2" type="text"
                                        class="item-input"/></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Process 3</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Process3}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Process3" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in process"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%" style="text-align:center">Details 3</td>
                                      <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Detail3}}</div>
                                      <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Detail3" type="text"
                                        class="item-input"/></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                      <td width="15%" class="header">Finish</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Finish}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Finish" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in finish"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select>
                                      </td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                  </tr>
                                  <tr>
                                      <td width="15%" class="header">Cavitation</td>
                                      <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Cavitation}}</div>
                                                  <el-select v-model="pdrOpenform.pdrFactice.comp2Cavitation" collapse-tags
                                            size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                                            placeholder="please choose">
                                          <el-option
                                          v-for="item in [1,2,4,6,8]"
                                          :key="item"
                                          :label="item"
                                          :value="item">
                                          <span style="float: left">{{ item }}</span>
                                        </el-option>
                                      </el-select></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                      <td width="10%"></td>
                                    </tr>
                                    <tr>
                                        <td width="15%" class="header">Color</td>
                                        <td width="10%">
                                      <div style="text-align: left;">{{pdrOpenform.pdrFactice.comp2Color}}</div>
                                      <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp2Color" type="text"
                                        class="item-input"/>
                                        </td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                        <td width="10%"></td>
                                    </tr>
                <tr>
                    <td width="15%" class="header">Sub-Component 3 Description</td>
                    <td width="10%" class="header1">inner</td>
                    <td width="10%" class="header1">Material</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Material}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Material" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in material"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select></td>
                    <td width="10%" class="header1">Tooling Price (RMB)</td>
                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3ToolingPriceR}}</div>
                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3ToolingPriceR" type="number"
                      @blur="checkToolingPriceR" class="item-input"/>--></td>
                    <td width="10%" class="header1">Tooling Price (USD)</td>
                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3ToolingPriceSpc}}</div>
                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3ToolingPriceSpc" type="number"
                     @blur="checkToolingPriceSpc" class="item-input"/>--></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 1</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Process1}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process1" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%" class="header1">details 1</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Detail1}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail1" type="text"
                      class="item-input"/></td>
                    <td width="10%" class="header1">Unit Price (RMB)</td>
                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3UnitPriceR}}</div>
                    <!--<input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3UnitPriceR" type="number"
                      @blur="checkUnitPriceR" class="item-input"/>--></td>
                    <td width="10%" class="header1">Unit Price (USD)</td>
                    <td width="10%" class="header"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3UnitPriceSpc}}</div>
<!--                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3UnitPriceSpc" type="number"
                      @blur="checkUnitPriceSpc" class="item-input"/>--></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 2</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Process2}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process2" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%" style="text-align:center">Details 2</td>
                    <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Detail2}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail2" type="text"
                      class="item-input"/></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Process 3</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Process3}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Process3" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in process"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%" style="text-align:center">Details 3</td>
                    <td width="10%" class="header1"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Detail3}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Detail3" type="text"
                      class="item-input"/></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Finish</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Finish}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Finish" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in finish"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                </tr>
                <tr>
                    <td width="15%" class="header">Cavitation</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Cavitation}}</div>
                                <el-select v-model="pdrOpenform.pdrFactice.comp3Cavitation" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in [1,2,4,6,8]"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                      <td width="15%" class="header">Color</td>
                      <td width="10%">
                    <div style="text-align: left;">{{pdrOpenform.pdrFactice.comp3Color}}</div>
                    <input v-if="operation==='edit' || operation==='add'" v-model="pdrOpenform.pdrFactice.comp3Color" type="text"
                      class="item-input"/>
                      </td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                      <td width="10%"></td>
                  </tr></template>
                  <template v-if="componentType === 'FC'">
                  <tr>
                      <td width="100%" class="section-header" colspan="8" rowspan="1">Folding Carton Options</td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Varnish</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.varnish}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.varnish" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Stamping</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.stamping}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.stamping" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Embossing</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.embossing}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.embossing" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Lamination</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.lamination}}</div>
                                <el-select v-model="pdrOpenform.pdrFc.lamination" collapse-tags
                          size="mini" style="display: flex;" v-if="operation==='edit' || operation==='add'"
                          placeholder="please choose">
                        <el-option
                        v-for="item in ['Yes', 'No']"
                        :key="item"
                        :label="item"
                        :value="item">
                        <span style="float: left">{{ item }}</span>
                      </el-option>
                    </el-select>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  </template>
                  <tr>
                      <td width="100%" class="section-header" colspan="8" rowspan="1">Conditions</td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Incoterm</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.incoterm}}</div>
                      <el-input v-model="pdrOpenform.pdrFc.incoterm"
                           v-if="operation==='edit' || operation==='add'" ></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">Sample LT (Days)</td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.sample}}</div>
                                <el-input v-model="pdrOpenform.pdrFc.sample"  v-if="operation==='edit' || operation==='add'"
                           class="item-input"></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
                  <tr>
                    <td width="15%" class="header">LT for MOQ (Days) </td>
                    <td width="10%"><div style="text-align: left;">{{pdrOpenform.pdrFc.moq}}</div>
                                <el-input v-model="pdrOpenform.pdrFc.moq"  v-if="operation==='edit' || operation==='add'" class="item-input"></el-input>
                    </td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                    <td width="10%"></td>
                  </tr>
          </tbody>
      </table>
      </div>
      <p>
          <br>
      </p>
    </el-form>
  </el-dialog>
      <!-- CRTask 列表区域 -->
      <el-table :data="crTaskList" border stripe style="width: 100%">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          prop="brand"
          label="Brand"         sortable
          width="90">
        </el-table-column>

        <el-table-column
          prop="prjDescription"  :show-overflow-tooltip="true"
          label="Project Name"     sortable
          width="250">
        </el-table-column>

        <el-table-column
          prop="projectSeqNo"      sortable
          label="Project Id"
          width="120">
        </el-table-column>

        <el-table-column
          prop="category"      sortable
          label="Item"
          width="90">
        </el-table-column>

        <el-table-column
          prop="customer"      sortable
          label="Customer"
          width="100">
        </el-table-column>

        <el-table-column
          prop="taskTobe"      sortable
          label="To Do By"
          width="100">
        </el-table-column>

        <el-table-column
          prop="status"            sortable
          label="Status"
          width="100">
        </el-table-column>

        <el-table-column
          prop="dueDate"                   :sort-method="sortBySchDate"
          label="Due Date"        sortable
          width="100"  :formatter="dateFormat">
        </el-table-column>

        <el-table-column
          prop="contact"        sortable
          label="Contact"     :show-overflow-tooltip="true"
          width="100">
        </el-table-column>

        <el-table-column
          label="Operation"
          width="456">
          <template slot-scope="props">
            <!--<el-popover placement="right" width="82%" trigger="click" @show="loadPdr(props.row.sequenceNo)" :title="`PDR`+`_`+pdrOpenform.pdr.projectId+`_`+pdrOpenform.pdr.projectDescr+`_`+pdrOpenform.pdr.createTime" class="dialogTitle"
    :visible.sync="popoverFormVisible">-->
  <!--<el-table :data="gridData">
    <el-table-column width="150" property="date" label="日期"></el-table-column>
    <el-table-column width="100" property="name" label="姓名"></el-table-column>
    <el-table-column width="300" property="address" label="地址"></el-table-column>
  </el-table>-->
  <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="loadPdr(props.row.sequenceNo)">Pdr</el-button>
<!--</el-popover>-->
            <!--<el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="jumpPdrState(props.row.id)">Pdr</el-button>-->
            <el-button type="info" v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="getRequestList(props.row)">QA</el-button>
            <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="dup(props.row.id)">Duplicate</el-button>
            <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
            <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="edit(props.row.id)">Edit</el-button>
            <el-button type="info"  v-if="userName.toUpperCase()==='J3P'" plain size="mini" @click="del(props.row.id)">Delete</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页区域-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="formInline.page"
        :page-sizes="[10, 20, 30, 50, 100, total]"
        :page-size="formInline.rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    // var checkEstimatedQty = (rule, value, callback) => {
    //   if (isNaN(value)) {
    //     callback(new Error('Please input number!'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      componentType: '',
      process: ['3D Printing', 'Anodizing', 'Assembling', 'Cellophane', 'Coating', 'Color', 'Degraded', 'Electroplating', 'Embossing', 'Filling', 'Frosting', 'Glitter', 'Hotstamping', 'Hard',
        'Injection', 'Molding', 'Natural', 'Padprinting', 'Polishing', 'Silkscreening', 'SoftTouch', 'Vac-metallized', 'Water Transfer', 'Label', 'Laser', 'CNC machining', 'Decal'],
      finish: ['Brushed', 'Matt', 'Shiny', 'Glossy', 'Varnish', 'N/A'],
      material: ['ABS', 'Acrylic', 'Aluminum', 'AS', 'Corrugated paper', 'Cooper', 'Foam', 'Glass', 'Nylon', 'Other', 'Paper', 'PBL', 'PCTA', 'PE', 'PET', 'PETG', 'PMMA', 'POM', 'PP', 'PS',
        'PVC', 'Silicone', 'Steel', 'Surlyn', 'Tin', 'Wood', 'Zamak'],
      firePolishList: ['Normal', 'Strong', 'No'],
      pdrOpenform: {
        pdr: '',
        pdrBottle: '',
        pdrFactice: '',
        pdrFc: ''
      },
      // userName: 'J3P',
      labelPosition: 'left',
      formInline: {
        projectId: '',
        sequenceNo: '',
        status: true,
        statusSearch: '',
        todoby: [],
        brands: [],
        dueDate: [],
        projectNm: '',
        customer: '',
        contact: '',
        token: '',
        page: 1,
        rows: 100
      },
      status: '',
      picList: [],
      docList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      operation: '',
      sites: [{
        code: 'E10',
        description: 'Easyfrenchy'
      }, {
        code: 'J10',
        description: 'J3P'
      }, {
        code: 'S10',
        description: 'SOURCING PERFUME COSMETIC SH LTD'
      }, {
        code: 'A10',
        description: 'PPI'
      }, {
        code: 'H10',
        description: 'Saphi HK'
      }, {
        code: 'P10',
        description: 'Saphired'
      }],
      activeName: 'task',
      taskOpenform: {
        createBy: '',
        // status: '',
        crTask: {
          id: -1,
          projectSeqNo: '',
          sequenceNo: '',
          customer: '',
          hidden: false,
          contact: '',
          product: '',
          completed: false,
          report: '',
          days: 0,
          moldNbr: 1,
          leadTime: 1,
          category: '',
          deco: '',
          status: '',
          taskTobe: '',
          material: '',
          dueDate: null,
          description: '',
          component: '',
          subComponent: '',
          material2: '',
          size: '',
          weight: '',
          weightUnit: '',
          decoration: '',
          printing: '',
          finish: '',
          moq: '',
          drawingNbr: '',
          createBy: ''
        },
        crProject: '',
        docReference: [],
        picReference: [],
        siteDescr: '',
        customerCompanyNm: '',
        projectDescr: '',
        projectPriority: '',
        productDescr: '',
        categoryDescr: '',
        decoDescr: '',
        materialDescr: '',
        statusDescr: '',
        projectLeader: ''
      },
      userName: '',
      loginname: '',
      loading: false,
      crTaskList: [],
      brandList: [],
      statusList: [],
      bpList: [],
      bpListbak: [],
      activeProjectList: [],
      activeProjectListbak: [],
      contactCRMList: [],
      contactCRMListbak: [],
      categoryList: [],
      productList: [],
      productListbak: [],
      decoList: [],
      customerNameList: [],
      salesRepList: [],
      statusSearchList: [],
      materialList: [],
      leadTimeValues: [],
      total: 0,
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      dueDateStart: '',
      pdrDialogFormVisible: false,
      dueDateEnd: '',
      dialogFormVisible: false,
      projectList: '',
      createdList: [],
      printingList: ['Off set', 'Silk Screen', 'Pad printing', '3D printing'],
      subComponentList: ['Inner cap', 'Outer cap', 'Weight', 'Magnet'],
      // finishList: ['']
      editFormRules: {
        crTask: {
          taskTobe: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          material: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          status: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          dueDate: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          createBy: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          updateBy: [
            { required: true, trigger: 'blur', message: 'Required' }
          ]
        }
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.loginname = window.sessionStorage.getItem('loginname').toUpperCase()
    this.formInline.token = window.sessionStorage.getItem('token')
    if (this.$route.params.selected) {
      this.formInline.projectId = this.$route.params.selected
      // window.sessionStorage.setItem('activePath', 'CRTask')
      // console.log('projectId === ' + this.$route.params.selected)
    }
    this.getBrands()
    this.getStatusList()
    this.getSalesReps()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getCRTasks()
    this.getSuppliers()
    this.getActiveCRProjects()
    this.getProducts()
    this.getTaskCategories()
    this.getDecos()
    this.getMaterials()
    this.getUserByList()
    this.getAllCustomers()
    this.getLeadTimeValues()
  },
  methods: {
    getRequestList (row) {
      console.log(row)
      this.$router.push(`/qaTestRequest?sequenceNo=${row.projectSeqNo}&bp=${row.customer}&brand=${row.brand}&description=${row.prjDescription}&projectLeader=${row.projectLeader}&status=${row.status}&contact=${row.contact}&category=${row.category}&material=${row.material}`)
    },
    jumpPdrState (value) {
      // window.sessionStorage.setItem('activePath', activePath)
      this.$router.push({ name: 'pdrLink', params: { selected: value } })
      // this.$router.push({ path: '/CRTask', query: { selected: value } })
      // console.log('activepath')
      // this.activePath = activePath
    },
    remoteMethodContact (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.contactCRMList = this.contactCRMListbak.filter(item => {
            return item.supplier.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.companyName.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.shortDescr.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.contactCRMList = this.contactCRMListbak
      }
    },
    completeChanged (value) {
      console.log('111')
      const that = this
      if (value === true) {
        this.$confirm('Do you want to complete the task?', 'Warning', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {
          console.log('confirma111')
          await that.confirmComplete(value)
          // this.$message({
          //   type: 'success',
          //   message: 'Delete completed!'
          // })
        }).catch(() => {
          if (value === true) {
            this.taskOpenform.crTask.completed = false
          } else {
            this.taskOpenform.crTask.completed = true
          }
          // this.$message({
          //   type: 'info',
          //   message: 'Delete canceled'
          // })
        })
      } else {
        this.$confirm('Do you want to incomplete the task?', 'Warning', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {
          console.log('confirma222')
          await that.confirmComplete(value)
          // this.$message({
          //   type: 'success',
          //   message: 'Delete completed!'
          // })
        }).catch(() => {
          if (value === true) {
            this.taskOpenform.crTask.completed = false
          } else {
            this.taskOpenform.crTask.completed = true
          }
          // this.$message({
          //   type: 'info',
          //   message: 'Delete canceled'
          // })
        })
      }
    },
    confirmComplete (value) {
      // Vue.prototype.$http = axios
      // const that = this
      /* if (this.taskOpenform.crTask.status && this.taskOpenform.crTask.status) {
        this.taskOpenform.crTask.status = [...this.taskOpenform.crTask.status].join(',')
        statusStr = this.taskOpenform.crTask.status
      } */
      console.log('this.taskOpenform.crTask.status === ' + this.taskOpenform.crTask.status)
      this.$http.get('/customer/completeCRTask', { params: { completed: value, projectId: this.taskOpenform.crTask.projectSeqNo, item: this.taskOpenform.crTask.category, status: this.taskOpenform.crTask.status, todoby: this.taskOpenform.crTask.taskTobe } })
        .then(res => {
          // that.getCRTasks()
          /* that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          }) */
        })
        .catch(error => {
          console.log(error)
          /* that.$message({
            message: '删除失败',
            type: 'error'
          }) */
        })
    },
    remoteMethodCustomer (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.bpList = this.bpListbak.filter(item => {
            return item.code.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.bpList = this.bpListbak
      }
    },
    remoteMethodProject (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.activeProjectList = this.activeProjectListbak.filter(item => {
            return item.sequenceNo.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.brand.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.description.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.bp.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.salesRep.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.activeProjectList = this.activeProjectListbak
      }
    },
    remoteMethodProduct (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.productList = this.productListbak.filter(item => {
            return item.product.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.description1.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.description2.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.project.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.category.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.productList = this.productListbak
      }
    },
    async siteChange (value) {
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === value) {
          this.taskOpenform.siteDescr = this.sites[i].description
        }
      }
      const { data: res } = await this.$http.get('/customer/getTaskSequenceNo?site=' + value)
      this.taskOpenform.crTask.sequenceNo = await res.sequenceNo
    },
    customerChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.customerCompanyNm = ''
      } else {
        for (var i = 0; i < this.bpList.length; i++) {
          if (this.bpList[i].code === value) {
            this.taskOpenform.customerCompanyNm = this.bpList[i].name
            break
          }
        }
      }
    },
    activeProjectChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.projectDescr = ''
        this.taskOpenform.crTask.projectLeader = ''
        this.taskOpenform.projectPriority = ''
      } else {
        for (var i = 0; i < this.activeProjectList.length; i++) {
          if (this.activeProjectList[i].sequenceNo === value) {
            this.taskOpenform.projectDescr = this.activeProjectList[i].description
            this.taskOpenform.crTask.projectLeader = this.activeProjectList[i].projectLeader
            console.log('this.activeProjectList[i].priority === ' + this.activeProjectList[i].priority)
            this.taskOpenform.projectPriority = this.activeProjectList[i].priority
            break
          }
        }
      }
    },
    productChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.productDescr = ''
      } else {
        for (var i = 0; i < this.productList.length; i++) {
          if (this.productList[i].product === value) {
            this.taskOpenform.productDescr = this.productList[i].description1
            break
          }
        }
      }
    },
    contactChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.contactName = ''
      } else {
        for (var i = 0; i < this.contactCRMList.length; i++) {
          if (this.contactCRMList[i].code === value) {
            this.taskOpenform.contactName = this.contactCRMList[i].lastName + ' ' + this.contactCRMList[i].firstName
            break
          }
        }
      }
    },
    categoryChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.categoryDescr = ''
      } else {
        for (var i = 0; i < this.categoryList.length; i++) {
          if (this.categoryList[i].code === value) {
            this.taskOpenform.categoryDescr = this.categoryList[i].description
            break
          }
        }
      }
    },
    salesRepChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.salesRepLastName = ''
      } else {
        for (var i = 0; i < this.salesRepList.length; i++) {
          if (this.salesRepList[i].salesRep === value) {
            this.taskOpenform.salesRepLastName = this.salesRepList[i].lastName
            break
          }
        }
      }
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!(file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.$message.error('The format must be JPG/PNG!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Must be less than 2MB!')
        return false
      }
    },
    handleAvatarSuccess (res, file) {
      this.$refs.upload.clearFiles()
      // this.form.picUrl = URL.createObjectURL(file.raw)
      this.form.machinePictureUrl = res
    },
    decoChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.decoDescr = ''
      } else {
        for (var i = 0; i < this.decoList.length; i++) {
          if (this.decoList[i].code === value) {
            this.taskOpenform.decoDescr = this.decoList[i].description
            break
          }
        }
      }
    },
    materialChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.materialDescr = ''
      } else {
        for (var i = 0; i < this.materialList.length; i++) {
          if (this.materialList[i].code === value) {
            this.taskOpenform.materialDescr = this.materialList[i].description
            break
          }
        }
      }
    },
    statusChange (value) {
      if (value === '' || value === null) {
        this.taskOpenform.statusDescr = ''
      } else {
        for (var i = 0; i < this.statusList.length; i++) {
          if (this.statusList[i].code === value) {
            this.taskOpenform.statusDescr = this.statusList[i].description
            break
          }
        }
      }
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    /* async getStatusList () {
      const { data: res6 } = await this.$http.get('/customer/getStatusList')
      this.statusSearchList = await res6.statusList
    }, */
    async getSuppliers () {
      const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      this.contactCRMList = await res2.bpSupplierList
      this.contactCRMListbak = this.contactCRMList
    },
    async getActiveCRProjects () {
      const { data: res10 } = await this.$http.get('/customer/getActiveCRProjectList')
      this.activeProjectList = await res10.activeProjectList
      this.activeProjectListbak = this.activeProjectList
    },
    async getProducts () {
      const { data: res11 } = await this.$http.get('/customer/getProductList')
      this.productList = await res11.productList
      this.productListbak = this.productList
    },
    async getTaskCategories () {
      const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      this.categoryList = await res3.taskCategoryList
    },
    async getDecos () {
      const { data: res4 } = await this.$http.get('/customer/getDecoList')
      this.decoList = await res4.decoList
    },
    async getMaterials () {
      const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      this.materialList = await res5.materialList
    },
    async getStatusList () {
      const { data: res6 } = await this.$http.get('/customer/getStatusList')
      this.statusList = await res6.statusList
    },
    async getUserByList () {
      const { data: res8 } = await this.$http.get('/customer/getUserByList')
      this.createdList = await res8.userByList
    },
    async getAllCustomers () {
      const { data: res } = await this.$http.get('/customerBrand/allcustomerList')
      this.bpList = await res.rows
      this.bpListbak = this.bpList
    },
    async getSalesReps () {
      const { data: res } = await this.$http.get('/customer/getSalesRepList')
      this.salesRepList = await res.salesRepList
    },
    async getProjectList (event) {
      const { data: res } = await this.$http.get('/customer/getCRProjectList?customer=' + event.target.value)
      this.projectList = await res.rows
    },
    async clearCustomerEvent () {
      const { data: res } = await this.$http.get('/customer/getCRProjectList?customer=')
      this.projectList = await res.rows
    },
    async getActiveProjectList () {
      const { data: res } = await this.$http.get('/customer/getActiveCRProjectList')
      this.activeProjectList = await res.activeProjectList
    },
    getLeadTimeValues () {
      for (var i = 1; i <= 99; i++) {
        this.leadTimeValues.push(i)
      }
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getCRTasks()
    },
    async taskDialogOpen () {
      this.operation = 'add'
      // this.getProjectList()
      this.taskOpenform.crProject = ''
      this.taskOpenform.siteDescr = ''
      this.taskOpenform.picReference = []
      this.taskOpenform.docReference = []
      this.taskOpenform.customerCompanyNm = ''
      this.taskOpenform.projectDescr = ''
      this.taskOpenform.projectPriority = ''
      this.taskOpenform.categoryDescr = ''
      this.taskOpenform.decoDescr = ''
      this.taskOpenform.materialDescr = ''
      this.taskOpenform.contactName = ''
      this.taskOpenform.statusDescr = ''
      this.taskOpenform.projectLeader = ''
      this.picList = []
      this.docList = []
      this.taskOpenform.crTask = { id: -1, projectSeqNo: '', sequenceNo: '', customer: '', hidden: false, contact: '', product: '', completed: false, report: '', days: 0, moldNbr: 1, leadTime: 1, category: '', deco: '', status: '', taskTobe: '', material: '', dueDate: null, description: '', component: '', subComponent: '', material2: '', size: '', weight: '', weightUnit: '', decoration: '', printing: '', finish: '', moq: '', drawingNbr: '', createBy: this.loginname }
      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = await res1.rows
      // this.bpListbak = this.bpList

      // const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      // this.contactCRMList = await res2.bpSupplierList
      // this.contactCRMListbak = this.contactCRMList

      // const { data: res10 } = await this.$http.get('/customer/getActiveCRProjectList')
      // this.activeProjectList = await res10.activeProjectList
      // this.activeProjectListbak = this.activeProjectList

      // const { data: res11 } = await this.$http.get('/customer/getProductList')
      // this.productList = await res11.productList
      // this.productListbak = this.productList

      // const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      // this.categoryList = await res3.taskCategoryList

      // const { data: res4 } = await this.$http.get('/customer/getDecoList')
      // this.decoList = await res4.decoList

      // const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      // this.materialList = await res5.materialList

      // const { data: res6 } = await this.$http.get('/customer/getStatusList')
      // this.statusList = await res6.statusList

      // const { data: res8 } = await this.$http.get('/customer/getUserByList')
      // this.createdList = await res8.userByList

      this.dialogFormVisible = true
    },
    async dup (value) {
      this.dialogFormVisible = true

      this.taskOpenform.siteDescr = ''
      this.taskOpenform.customerCompanyNm = ''
      this.taskOpenform.projectDescr = ''
      this.taskOpenform.projectPriority = ''
      this.taskOpenform.categoryDescr = ''
      this.taskOpenform.decoDescr = ''
      this.taskOpenform.materialDescr = ''
      this.taskOpenform.statusDescr = ''
      this.taskOpenform.projectLeader = ''
      this.operation = 'add'
      const { data: res } = await this.$http.get('/customer/getCRTask', { params: { value: value } })

      if (res.crTask.dueDate !== null) {
        res.crTask.dueDate = res.crTask.dueDate.substr(0, 10).replace('/', '-').replace('/', '-')
        // console.log('res.crTask.dueDate === ' + res.crTask.dueDate)
      }

      this.taskOpenform.crTask = res.crTask

      const { data: resSeq } = await this.$http.get('/customer/getTaskSequenceNo?site=' + res.crTask.site)
      this.taskOpenform.crTask.sequenceNo = await resSeq.sequenceNo
      this.taskOpenform.crTask.createBy = this.loginname

      this.taskOpenform.crTask.id = -1
      // this.taskOpenform.crTask.report = null
      // this.taskOpenform.crTask.description = null
      if (res.crTask.contact !== null && res.crTask.contact !== '') {
        if (res.crTask.contact.substr(0, 1) === '[') {
          res.crTask.contact = res.crTask.contact.substr(1, res.crTask.contact.length - 2)
          await this.$set(this.taskOpenform.crTask, 'contact', res.crTask.contact.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'contact', res.crTask.contact.split(','))
        }
      }
      if (res.crTask.deco !== null && res.crTask.deco !== '') {
        if (res.crTask.deco.substr(0, 1) === '[') {
          res.crTask.deco = res.crTask.deco.substr(1, res.crTask.deco.length - 2)
          await this.$set(this.taskOpenform.crTask, 'deco', res.crTask.deco.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'deco', res.crTask.deco.split(','))
        }
      }
      /* if (res.crTask.status !== null && res.crTask.status !== '') {
        if (res.crTask.status.substr(0, 1) === '[') {
          res.crTask.status = res.crTask.status.substr(1, res.crTask.status.length - 2)
          await this.$set(this.taskOpenform.crTask, 'status', res.crTask.status.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'status', res.crTask.status.split(','))
        }
      } */
      // console.log('res.crTask.dueDate === ' + res.crTask.dueDate)

      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === res.crTask.site) {
          this.taskOpenform.siteDescr = this.sites[i].description
        }
      }

      this.taskOpenform.picReference = []
      this.taskOpenform.docReference = []
      this.picList = []
      this.docList = []
      if (res.fPicfileList !== null && res.fPicfileList.length > 0) {
        for (var k = 0; k < res.fPicfileList.length; k++) {
          this.picList.push({ name: res.fPicfileList[k].fileName, url: 'https://www.myirequest.com:8081/' + res.fPicfileList[k].fileName })
          this.taskOpenform.picReference.push({ fileName: res.fPicfileList[k].fileName, type: 'picture' })
        }
      }
      if (res.fDocfileList !== null && res.fDocfileList.length > 0) {
        for (var j = 0; j < res.fDocfileList.length; j++) {
          this.docList.push({ name: res.fDocfileList[j].fileName, url: 'https://www.myirequest.com:8081/' + res.fDocfileList[j].fileName })
          this.taskOpenform.docReference.push({ fileName: res.fDocfileList[j].fileName, type: 'document' })
        }
      }
      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = await res1.rows
      // this.bpListbak = this.bpList
      this.customerChange(res.crTask.customer)

      // const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      // this.contactCRMList = await res2.bpSupplierList
      // this.contactCRMListbak = this.contactCRMList
      this.contactChange(res.crTask.contact)

      // const { data: res9 } = await this.$http.get('/customer/getActiveCRProjectList')
      // this.activeProjectList = await res9.activeProjectList
      // this.activeProjectListbak = this.activeProjectList
      this.activeProjectChange(res.crTask.projectSeqNo)

      // const { data: res11 } = await this.$http.get('/customer/getProductList')
      // this.productList = await res11.productList
      // this.productListbak = this.productList
      this.productChange(res.crTask.product)

      // const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      // this.categoryList = await res3.taskCategoryList
      this.categoryChange(res.crTask.category)

      // const { data: res4 } = await this.$http.get('/customer/getDecoList')
      // this.decoList = await res4.decoList
      this.decoChange(res.crTask.deco)

      // const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      // this.materialList = await res5.materialList
      this.materialChange(res.crTask.material)

      // const { data: res6 } = await this.$http.get('/customer/getStatusList')
      // this.statusList = await res6.statusList
      this.statusChange(res.crTask.status)

      // const { data: res8 } = await this.$http.get('/customer/getUserByList')
      // this.createdList = await res8.userByList
    },
    async loadPdr (value) {
      this.pdrDialogFormVisible = true
      this.operation = 'view'
      const { data: res } = await this.$http.get('/pdr/getPdrbyTaskSeqNo', { params: { value: value } })
      this.componentType = res.componentType
      console.log('componentTYpe === ' + this.componentType)
      this.pdrOpenform.pdr = res.pdr
      this.pdrOpenform.pdrBottle = res.pdrBottle
      console.log('customerid === ' + res.pdr.customerId)
      this.pdrOpenform.pdrFactice = res.pdrFactice
      this.pdrOpenform.pdrFc = res.pdrFc

      var date = new Date(res.pdr.createTime)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = '' + month
      var day = date.getDate()

      console.log('month === ' + month.length)
      if (month.length === 1) {
        console.log('11111111')
        month = '0' + month
      }
      this.currentDate = 'PDR VERSION ' + day + '/' + month + '/' + year
      console.log('currentDate === ' + month)
      // this.dialogFormVisible.print()
    },
    async edit (value) {
      this.dialogFormVisible = true

      this.taskOpenform.siteDescr = ''
      this.taskOpenform.customerCompanyNm = ''
      this.taskOpenform.projectDescr = ''
      this.taskOpenform.projectPriority = ''
      this.taskOpenform.categoryDescr = ''
      this.taskOpenform.decoDescr = ''
      this.taskOpenform.materialDescr = ''
      this.taskOpenform.statusDescr = ''
      this.taskOpenform.projectLeader = ''
      this.operation = 'edit'
      const { data: res } = await this.$http.get('/customer/getCRTask', { params: { value: value } })
      if (res.crTask.dueDate !== null) {
        res.crTask.dueDate = res.crTask.dueDate.substr(0, 10).replace('/', '-').replace('/', '-')
        // console.log('res.crTask.dueDate === ' + res.crTask.dueDate)
      }

      this.taskOpenform.crTask = res.crTask

      if (res.crTask.contact !== null && res.crTask.contact !== '') {
        if (res.crTask.contact.substr(0, 1) === '[') {
          res.crTask.contact = res.crTask.contact.substr(1, res.crTask.contact.length - 2)
          await this.$set(this.taskOpenform.crTask, 'contact', res.crTask.contact.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'contact', res.crTask.contact.split(','))
        }
      }
      if (res.crTask.deco !== null && res.crTask.deco !== '') {
        if (res.crTask.deco.substr(0, 1) === '[') {
          res.crTask.deco = res.crTask.deco.substr(1, res.crTask.deco.length - 2)
          await this.$set(this.taskOpenform.crTask, 'deco', res.crTask.deco.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'deco', res.crTask.deco.split(','))
        }
      }
      /* if (res.crTask.status !== null && res.crTask.status !== '') {
        if (res.crTask.status.substr(0, 1) === '[') {
          res.crTask.status = res.crTask.status.substr(1, res.crTask.status.length - 2)
          await this.$set(this.taskOpenform.crTask, 'status', res.crTask.status.split(','))
        } else {
          await this.$set(this.taskOpenform.crTask, 'status', res.crTask.status.split(','))
        }
      } */
      // console.log('res.crTask.dueDate === ' + res.crTask.dueDate)

      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === res.crTask.site) {
          this.taskOpenform.siteDescr = this.sites[i].description
        }
      }

      this.taskOpenform.picReference = []
      this.taskOpenform.docReference = []
      this.picList = []
      this.docList = []
      if (res.fPicfileList !== null && res.fPicfileList.length > 0) {
        for (var k = 0; k < res.fPicfileList.length; k++) {
          this.picList.push({ name: res.fPicfileList[k].fileName, url: 'https://www.myirequest.com:8081/' + res.fPicfileList[k].fileName })
          this.taskOpenform.picReference.push({ fileName: res.fPicfileList[k].fileName, type: 'picture' })
        }
      }
      if (res.fDocfileList !== null && res.fDocfileList.length > 0) {
        for (var j = 0; j < res.fDocfileList.length; j++) {
          this.docList.push({ name: res.fDocfileList[j].fileName, url: 'https://www.myirequest.com:8081/' + res.fDocfileList[j].fileName })
          this.taskOpenform.docReference.push({ fileName: res.fDocfileList[j].fileName, type: 'document' })
        }
      }
      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = await res1.rows
      // this.bpListbak = this.bpList
      this.customerChange(res.crTask.customer)

      // const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      // this.contactCRMList = await res2.bpSupplierList
      // this.contactCRMListbak = this.contactCRMList
      this.contactChange(res.crTask.contact)

      // const { data: res9 } = await this.$http.get('/customer/getActiveCRProjectList')
      // this.activeProjectList = await res9.activeProjectList
      // this.activeProjectListbak = this.activeProjectList
      this.activeProjectChange(res.crTask.projectSeqNo)

      // const { data: res11 } = await this.$http.get('/customer/getProductList')
      // this.productList = await res11.productList
      // this.productListbak = this.productList
      this.productChange(res.crTask.product)

      // const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      // this.categoryList = await res3.taskCategoryList
      this.categoryChange(res.crTask.category)

      // const { data: res4 } = await this.$http.get('/customer/getDecoList')
      // this.decoList = await res4.decoList
      this.decoChange(res.crTask.deco)

      // const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      // this.materialList = await res5.materialList
      this.materialChange(res.crTask.material)

      // const { data: res6 } = await this.$http.get('/customer/getStatusList')
      // this.statusList = await res6.statusList
      this.statusChange(res.crTask.status)

      // const { data: res8 } = await this.$http.get('/customer/getUserByList')
      // this.createdList = await res8.userByList
    },
    async view (value) {
      this.operation = 'view'
      const { data: res } = await this.$http.get('/customer/getCRTask', { params: { value: value } })
      this.taskOpenform.crTask = res.crTask
      if (res.crTask.dueDate !== null) {
        res.crTask.dueDate = res.crTask.dueDate.substr(0, 10).replace('/', '-').replace('/', '-')
        // console.log('res.crTask.dueDate === ' + res.crTask.dueDate)
      }

      if (res.crTask.contact !== null && res.crTask.contact !== '') {
        if (res.crTask.contact.substr(0, 1) === '[') {
          res.crTask.contact = res.crTask.contact.substr(1, res.crTask.contact.length - 2)
          await this.$set(this.taskOpenform.crTask, 'contact', res.crTask.contact.split(','))
        }
      }
      if (res.crTask.deco !== null && res.crTask.deco !== '') {
        if (res.crTask.deco.substr(0, 1) === '[') {
          res.crTask.deco = res.crTask.deco.substr(1, res.crTask.deco.length - 2)
          await this.$set(this.taskOpenform.crTask, 'deco', res.crTask.deco.split(','))
        }
      }
      /* if (res.crTask.status !== null && res.crTask.status !== '') {
        if (res.crTask.status.substr(0, 1) === '[') {
          res.crTask.status = res.crTask.status.substr(1, res.crTask.status.length - 2)
          await this.$set(this.taskOpenform.crTask, 'status', res.crTask.status.split(','))
        }
      } */

      // console.log('due date ===' + this.taskOpenform.crTask.dueDate)
      for (var i = 0; i < this.sites.length; i++) {
        if (this.sites[i].code === res.crTask.site) {
          this.taskOpenform.siteDescr = this.sites[i].description
        }
      }
      // const { data: res1 } = await this.$http.get('/customerBrand/allcustomerList')
      // this.bpList = await res1.rows
      this.customerChange(res.crTask.customer)
      // const { data: res2 } = await this.$http.get('/customer/getSupplierList')
      // this.contactCRMList = await res2.bpSupplierList
      this.contactChange(res.crTask.contact)
      // const { data: res9 } = await this.$http.get('/customer/getActiveCRProjectList')
      // this.activeProjectList = await res9.activeProjectList
      this.activeProjectChange(res.crTask.projectSeqNo)
      // const { data: res11 } = await this.$http.get('/customer/getProductList')
      // this.productList = await res11.productList
      this.productChange(res.crTask.product)
      // const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      // this.categoryList = await res3.taskCategoryList
      this.categoryChange(res.crTask.category)
      // const { data: res4 } = await this.$http.get('/customer/getDecoList')
      // this.decoList = await res4.decoListcrTaskList
      this.decoChange(res.crTask.deco)
      // const { data: res5 } = await this.$http.get('/customer/getMaterialList')
      // this.materialList = await res5.materialList
      this.materialChange(res.crTask.material)
      // const { data: res6 } = await this.$http.get('/customer/getStatusList')
      // this.statusList = await res6.statusList
      this.statusChange(res.crTask.status)

      this.operation = 'view'
      this.dialogFormVisible = true
    },
    async taskDialogSave (formName) {
      this.$refs[formName].validate(valid => {
        // console.log('status === ' + this.taskOpenform.status)
        if (valid) {
          console.log('已提交表单')
          // console.log('this.taskOpenform.crTask.dueDate === ' + this.taskOpenform.crTask.dueDate)
          if (this.taskOpenform.contact && this.taskOpenform.contact.length) {
            this.taskOpenform.contact = [...this.taskOpenform.contact].join(',')
          }
          if (this.taskOpenform.deco && this.taskOpenform.deco.length) {
            this.taskOpenform.deco = [...this.taskOpenform.deco].join(',')
          }
          /* if (this.taskOpenform.status && this.taskOpenform.status.length) {
            this.taskOpenform.status = [...this.taskOpenform.status].join(',')
          } */
          this.$http.post('/customer/crTaskSave', { params: this.taskOpenform })

          this.dialogFormVisible = false
          this.$message.success('Update successfully!')
          setTimeout(() => {
            this.getCRTasks()
          }, 200)
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // if (isNaN(this.taskOpenform.crTask.days)) {
      //   this.$alert('Days should be number', 'Alert', {
      //     dangerouslyUseHTMLString: true
      //   })
      //   return
      // }

      // for (var h = 0; h < this.projectOpenform.competitorList.length; k++) {
      //   if (isNaN(this.projectOpenform.competitorList[h].competitorAmt)) {
      //     this.$alert('Competitor Amt should be number', 'Alert', {
      //       dangerouslyUseHTMLString: true
      //     })
      //   }
      // }

      // await this.$http.post('/customer/crProjectSave', { param1: this.projectOpenform, param2: this.stepList, param3: this.associatedPrjList, param4: this.competitorList })
      // await this.$http.post('/customer/crTaskSave', { params: this.taskOpenform })

      // this.dialogFormVisible = false
      // this.$message.success('Update successfully!')

      // this.getCRTasks()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // exportToExcel () {
    //   /* 表示在当前页面打开新地址 */
    //   window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product, '_parent')
    // },
    async getCRTasks () {
      // console.log('111111111')
      var brandsStr = ''
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      var todobyStr = ''
      if (this.formInline.todoby && this.formInline.todoby.length) {
        this.formInline.todoby = [...this.formInline.todoby].join(',')
        todobyStr = this.formInline.todoby
      }

      this.dueDateStart = ''
      this.dueDateEnd = ''
      console.log('this.formInline.dueDate === ' + this.formInline.dueDate + '111')

      // console.log('this.formInline.dueDate.indexOf(",") === ' + this.formInline.dueDate.indexOf(','))

      if (this.formInline.dueDate && this.formInline.dueDate.indexOf(',') !== 0) {
        if (this.formInline.dueDate.length) {
          this.dueDateStart = this.formInline.dueDate[0]
          this.dueDateEnd = this.formInline.dueDate[1]
          this.formInline.dueDate = [...this.formInline.dueDate].join(',')
        }
      }
      const { data: res } = await this.$http.get('/customer/crTaskList', { params: this.formInline })
      this.crTaskList = res.rows
      this.total = res.total
      console.log('this.total === ' + this.total)

      // console.log('555555555555')
      await this.$set(this.formInline, 'dueDate', [this.dueDateStart, this.dueDateEnd])

      // console.log('333333333')
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      if (todobyStr !== '') {
        await this.$set(this.formInline, 'todoby', todobyStr.split(','))
      }
      // this.formInline.projectId = ''
    },
    handleRemovePic (file, fileList) {
      // this.fileParam.files = file
      // this.fileParam.fileName = file.name
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // await this.$http.get('/customer/fileRemove', { params: this.fileParam })
      for (var i = 0; i < this.taskOpenform.picReference.length; i++) {
        if (file.name === this.taskOpenform.picReference[i].fileName) {
          this.taskOpenform.picReference.splice(i, 1)
        }
      }
    },
    handleRemoveDoc (file, fileList) {
      for (var i = 0; i < this.taskOpenform.docReference.length; i++) {
        if (file.name === this.taskOpenform.docReference[i].fileName) {
          this.taskOpenform.docReference.splice(i, 1)
        }
      }
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      console.log('file.url === ' + file.url)
      this.dialogVisible = true
    },
    handlePreviewDoc (file) {
      // let params = {}
      // console.log('fileList doc === ' + fileList)
      const url = 'https://www.myirequest.com:8081/' + file.name
      // params = JSON.parse(url)
      const len = url.lastIndexOf('.')
      const type = url.substring(len + 1)
      if (
        type === 'doc' ||
        type === 'docx' ||
        type === 'xlsx' ||
        type === 'xls' ||
        type === 'ppt' ||
        type === 'pptx' ||
        // type === 'pdf' ||
        type === 'csv'
      ) {
        document.location.href = url
      } else {
        window.open(url, 'hello')
      }
      // } else {
      //   // 圖片會直接在瀏覽器中打開所以，打開新的頁面
      //   window.open(params.url, 'hello')
      // }
      // if (
      //   type === 'doc' ||
      //   type === 'docx' ||
      //   type === 'xlsx' ||
      //   type === 'xls' ||
      //   type === 'ppt' ||
      //   type === 'pptx' ||
      //   type === 'csv'
      // ) {
      //   console.log('params.url === ' + params.url)
      //   document.location.href = params.url
      // } else {
      //   // 圖片會直接在瀏覽器中打開所以，打開新的頁面
      //   window.open(params.url, 'hello')
      // }
    },
    async handleUploadFileList () {
      const formData = new FormData()
      this.picList.forEach((_) => {
        formData.append('file', _.raw)
      })
      // const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      await this.$http.post(`//172.0.0.1:8081/fileHandler?sequenceNo=${this.taskOpenform.crProject.sequenceNo}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then((r) => {
        console.log(r)
      }).catch((e) => {
        console.log(e)
      })
    },
    beforeUpload (file) {
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: 'Warning',
          message: 'Please upload image/png, image/gif, image/jpg, image/jpeg pictures.'
        })
        return false
      }
      const size = file.size / 1024 / 1024
      if (size > 10) {
        this.$notify.warning({
          title: 'Warning',
          message: 'Pictures with a size less than 10M.'
        })
        return false
      }
    },
    handleSuccessPic (response, file, fileList) {
      this.taskOpenform.picReference.push({ fileName: file.name, type: 'picture' })
      // console.log('fileList === ' + this.fileList)
      // console.log('res.status === ' + fileList)
      // this.fileParam.files = fileList.
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // const { data: res } = await this.$http.get('/customer/fileHandler', { params: this.fileParam })
      // this.brandList = await res.brands
      // if (response.status === 1) {
      //   console.log('fileList333333333333====== ' + fileList)
      // }
    },
    handleSuccessDoc (response, file, fileList) {
      this.taskOpenform.docReference.push({ fileName: file.name, type: 'document' })
      // this.taskOpenform.reference.push(file.name)
      // console.log('fileList === ' + this.fileList)
      // console.log('res.status === ' + fileList)
      // this.fileParam.files = fileList.
      // this.fileParam.sequenceNo = this.projectOpenform.crProject.sequenceNo
      // const { data: res } = await this.$http.get('/customer/fileHandler', { params: this.fileParam })
      // this.brandList = await res.brands
      // if (response.status === 1) {
      //   console.log('fileList333333333333====== ' + fileList)
      // }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    del (value) {
      const that = this
      this.$confirm('This will permanently delete the Task. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/customer/deleteCRTask', { params: { value: value } })
        .then(res => {
          that.getCRTasks()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc111===' + daterc)
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getCRTasks()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getCRTasks()
    },
    sortBySchDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.dueDate).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.dueDate).getTime() / 1000)
      return val1 - val2
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .textarea-class {
    // width: 80%;
    border: 1px solid #000;
    margin: 10px 10px 10px 10px;
  }
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
  .div-class {
    border:solid 1px #000;
  }
  .div-class2 {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-project-class {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-title-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    background-color: rgba(156, 156, 156);
    text-align: left;
  }
  .div-titlefin-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    margin-top:5px;
    text-align: left;
    background-color: rgba(156, 156, 156);
  }
  .div-capaday-class {
    margin-top:5px;
    border:solid 1px #000;
    padding-top:10px;
  }
  .div-nextstep-class1 {
    border:solid 1px #000;
    margin-bottom: 5px;
    padding-top:10px;
    // line-height: 50px;
  }
  #dialogTitle {
    text-align: center;
  }
  /*.dialogTitle{
    text-align: center;
    position: relative;
    left: 0px;
    }*/
  .div-table {
    // font-size: 12px;
    // border-right: 1px solid #999;
    // border-right-width: medium;
    // border-right-style: none;
    // border-right-color: currentColor;
    // border-right: none;
    // border-right-color: ;
    // border-bottom: none;
    // border-bottom-color: ;
    // box-sizing: border-box;
    // border: 5px
    // width: 100%;
    // margin-bottom: 4px;
    // margin-top: 4px;
  }
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }

  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }

  .header {
    // width: 39%;
    text-align: left;
    font-weight: bold;
  }
  .header1 {
    text-align: center;
    font-weight: 500;
    word-break: keep-all;
  }
  .item-header {
    text-align: left;
    font-weight: 300;
  }
  .item-input {
   width: 95%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input1 {
   width: 99%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input2 {
   width: 59%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input-required:required {
   width: 59%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
</style>
